import React from 'react';
import PropTypes from 'prop-types';
import document from 'global/document';
import window from 'global/window';
import classNames from 'classnames';

const modal =
  (options = {}) =>
  Component =>
    class extends React.Component {
      static propTypes = {
        activeModal: PropTypes.bool,
      };

      static defaultProps = {
        activeModal: false,
      };

      constructor(props) {
        super(props);
        this.scrollTop = null;
      }

      componentDidMount() {
        if (this.props.activeModal) {
          this.active();
        }
      }

      componentWillUnmount() {
        this.inactive();
      }

      componentWillReceiveProps(nextProps) {
        if (!this.props.activeModal && nextProps.activeModal) {
          this.active();
        } else if (this.props.activeModal && !nextProps.activeModal) {
          this.inactive();
        }
      }

      active = () => {
        this.scrollTop = window.scrollTop || window.pageYOffset;
        document.body.classList.add('body-ovh');
      };

      inactive = () => {
        document.body.classList.remove('body-ovh');

        if (this.scrollTop) {
          window.scrollTo(0, this.scrollTop);
        }

        this.scrollTop = null;
      };

      render() {
        return (
          <div
            className={classNames('modal', options.className, {
              'modal--active': this.props.activeModal,
            })}
          >
            <div className="modal__content">
              <Component {...this.props} />
            </div>
          </div>
        );
      }
    };

export default modal;
